<template>
  <div class="cs-default-layout">
    <!-- <resize-sensor @resize="HeightTransition" /> -->
    <div class="cs-default-container">
      <magiclogin />
      <Header />
      <!-- <div class="main-wraper"> -->
      <slot />
      <!-- </div> -->
      <PoweredBy />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import PoweredBy from '@/components/PoweredBy.vue';
import { mapGetters } from "vuex";

export default {
  name: 'default-layout',
  components: {
    Header,
    PoweredBy,
  },
  computed: {
    ...mapGetters({
      hostedPageId: "user/getHostedPageId",
      cart: 'user/cart'
    }),
  },
  mounted() {
    this.$nextTick(async () => {
      // coinbase window check
      const searchParams = new URL(window.location).searchParams;
      if(searchParams.get('code')) {
        return;
      }
      // dont redirect if the page is the hosted page
      if (!window.location.pathname === "/" || !window.location.pathname.includes('hostedPage')) {
        if (this.hostedPageId && !Object.keys(this.cart).length) {
          this.$router.push({ name: 'HostedPage', params: { id: this.hostedPageId } })
        } else if (!this.hostedPageId && !Object.keys(this.cart).length) {
          this.invalidOrder()
        }
      }
    });
  },
  methods: {
    HeightTransition() {
      document.getElementsByTagName('body')[0].style.height = '';
      this.heightTo = document.getElementsByTagName('body')[0].offsetHeight;
      this.notifyParentWindow({
        type: 'rocketfuel_change_height',
        data: `${this.heightTo}px`,
      });
      this.notifyParentWindow({
        type: 'rocketfuel_new_height',
        data: this.heightTo,
      });
      document.getElementsByTagName('body')[0].style.height = `${this.heightTo}px`;
    },
  },
};
</script>

<style lang="scss">
$default-container-width: 350px;
// .main-wraper{
//   height: 540px;
//   overflow-y: auto;
// }

.cs-default-layout {
  height: 100%;
  width: 100%;
}

.cs-default-container {
  width: $default-container-width;
  margin: 30px auto;
  overflow-y: auto;
  background-color: #FFFFFF;
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  box-shadow: 0 0 5px rgba(12, 12, 12, 0.5);
  border-radius: 5px;
  @media (max-width: 1024px) {
    margin: 30px auto;
    width: $default-container-width;
    /* Adjust the width for tablets */
  }

  @media (max-width: 768px) {
    width: $default-container-width;
    /* Adjust the width for standard mobile devices */
    margin: 30px auto;
  }

  @media (max-width: 480px) {
    width: 100%;
    /* Adjust the width for small mobile devices */
    height: 100vh;
    margin: auto;
    padding: 10px;
  }
}
</style>
